let GLOBAL_SERVER = (window as any).server;
if (GLOBAL_SERVER) {
    try {
        const tmpServerVar = JSON.parse(GLOBAL_SERVER);
        GLOBAL_SERVER = tmpServerVar;
    } catch (error) {}
}

export const API_CLIENT_ID: string = process.env.REACT_APP_API_CLIENT_ID || "5ECBj0QMxCfbKEvQhwFeh0sXDVPgJr36GT3gMu2a";
export const API_CLIENT_SECRET: string = process.env.REACT_APP_API_CLIENT_SECRET || "IGwOgicim678iyUhQMomnJiDOVQyWwtJstq8LSkB";

export const PROTOCOL: string = GLOBAL_SERVER && GLOBAL_SERVER.isSsl ? "https" : null || process.env.REACT_APP_PROTOCOL || "http";
export const DOMAIN: string =
    (GLOBAL_SERVER && GLOBAL_SERVER.homeUrl ? GLOBAL_SERVER.homeUrl.replace("http://", "").replace("https://", "") : null) ||
    process.env.REACT_APP_DOMAIN ||
    "localhost:8100";

export const WP_JSON: string = "/wp-json";
export const HOST: string = PROTOCOL + "://" + DOMAIN;
export const JWT: string = "/jwt-auth/v1";
export const GET_TOKEN_ENDPOINT: string = HOST + WP_JSON + JWT + "/token";
export const VALIDATE_TOKEN_ENDPOINT: string = GET_TOKEN_ENDPOINT + "/validate";

export const FILTER: string = "/filter";
export const NEW: string = "/new";
export const EDIT: string = "/edit";
export const CATEGORIES: string = "/categories";
export const PROFESSION: string = "/profession";
export const SCHOOL: string = "/school";
export const SEARCH: string = "/profession-school";
export const SEARCH_PARAM: string = "s";
export const TAXONOMIES_PARAM: string = "tax";

// Get single
export const GET_PROFESSION_ENDPOINT: string = HOST + WP_JSON + PROFESSION + "/";
export const GET_SCHOOL_ENDPOINT: string = HOST + WP_JSON + SCHOOL + "/";

// Get filtered
export const FILTER_PROFESSION_ENDPOINT: string = HOST + WP_JSON + PROFESSION + FILTER;
export const FILTER_SCHOOL_ENDPOINT: string = HOST + WP_JSON + SCHOOL + FILTER;

// Get cateogories
export const GET_PROFESSION_CATEGORIES_ENDPOINT: string = HOST + WP_JSON + PROFESSION + CATEGORIES;
export const GET_SCHOOL_CATEGORIES_ENDPOINT: string = HOST + WP_JSON + SCHOOL + CATEGORIES;

// Search
export const SEARCH_ENDPOINT: string = HOST + WP_JSON + SEARCH + FILTER;

// Create
export const SEND_NEW_PROFESSION_ENDPOINT: string = HOST + WP_JSON + PROFESSION + NEW;
export const SEND_NEW_SCHOOL_ENDPOINT: string = HOST + WP_JSON + SCHOOL + NEW;

// Update
export const SEND_EDIT_PROFESSION_ENDPOINT: string = HOST + WP_JSON + PROFESSION + EDIT;
export const SEND_EDIT_SCHOOL_ENDPOINT: string = HOST + WP_JSON + SCHOOL + EDIT;

// DELETE
export const DELETE_PROFESSION_ENDPOINT: string = HOST + WP_JSON + PROFESSION + "/";
export const DELETE_SCHOOL_ENDPOINT: string = HOST + WP_JSON + SCHOOL + "/";
